import { render, staticRenderFns } from "./BWSelect.vue?vue&type=template&id=50f3165f&scoped=true"
import script from "./BWSelect.vue?vue&type=script&lang=js"
export * from "./BWSelect.vue?vue&type=script&lang=js"
import style0 from "./BWSelect.vue?vue&type=style&index=0&id=50f3165f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f3165f",
  null
  
)

export default component.exports